var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_85_1",
    "data-name": "Component 85 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 47,
    viewBox: "0 0 71 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    d: "M0,0H28a0,0,0,0,1,0,0V19a9,9,0,0,1-9,9H9a9,9,0,0,1-9-9V0A0,0,0,0,1,0,0Z",
    transform: "translate(47 28) rotate(180)",
    fill: "#1d6bb3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_84_1",
    "data-name": "Component 84 \\u2013 1",
    transform: "translate(0 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    d: "M0,0H19a0,0,0,0,1,0,0V4A15,15,0,0,1,4,19H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(19 19) rotate(180)",
    fill: "#ef5a2a"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    d: "M0,0H19a0,0,0,0,1,0,0V4A15,15,0,0,1,4,19H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(52 47) rotate(-90)",
    fill: "#1d6bb3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadColored);
export default __webpack_public_path__ + "static/media/lead-colored.835867c2d271fd85826e70f58e293dc0.svg";
export { ForwardRef as ReactComponent };